import React from 'react';
import { X, AlertCircle, Mail, ArrowUpCircle } from 'lucide-react';

const StudentLimitModal = ({ isOpen, onClose, currentCount, maxAllowed, onUpgrade }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className="bg-white dark:bg-gray-800 rounded-lg shadow-xl max-w-md w-full">
        {/* Header */}
        <div className="flex items-center justify-between p-6 border-b border-gray-200 dark:border-gray-700">
          <div className="flex items-center space-x-3">
            <div className="w-12 h-12 bg-red-100 dark:bg-red-900/30 rounded-full flex items-center justify-center">
              <AlertCircle className="w-6 h-6 text-red-600 dark:text-red-400" />
            </div>
            <div>
              <h3 className="text-lg font-semibold text-gray-900 dark:text-white">
                Student Limit Reached
              </h3>
              <p className="text-sm text-gray-500 dark:text-gray-400">
                {currentCount}/{maxAllowed} students
              </p>
            </div>
          </div>
          <button
            onClick={onClose}
            className="text-gray-400 hover:text-gray-600 dark:hover:text-gray-300"
          >
            <X className="w-5 h-5" />
          </button>
        </div>

        {/* Content */}
        <div className="p-6 space-y-4">
          <p className="text-gray-700 dark:text-gray-300">
            You've reached your plan's student limit. To add more students, you can:
          </p>

          {/* Upgrade Option */}
          <button
            onClick={onUpgrade}
            className="w-full flex items-center justify-between p-4 bg-primary-50 dark:bg-primary-900/20 border-2 border-primary-500 rounded-lg hover:bg-primary-100 dark:hover:bg-primary-900/30 transition-colors"
          >
            <div className="flex items-center space-x-3">
              <ArrowUpCircle className="w-5 h-5 text-primary-600 dark:text-primary-400" />
              <div className="text-left">
                <p className="font-semibold text-primary-700 dark:text-primary-300">
                  Upgrade Your Plan
                </p>
                <p className="text-sm text-primary-600 dark:text-primary-400">
                  Instant activation, add more students
                </p>
              </div>
            </div>
            <span className="text-primary-600 dark:text-primary-400">→</span>
          </button>

          {/* Divider */}
          <div className="relative">
            <div className="absolute inset-0 flex items-center">
              <div className="w-full border-t border-gray-300 dark:border-gray-600"></div>
            </div>
            <div className="relative flex justify-center text-sm">
              <span className="px-2 bg-white dark:bg-gray-800 text-gray-500 dark:text-gray-400">
                or contact support
              </span>
            </div>
          </div>

          {/* Contact Support */}
          <a
            href="mailto:support@mahstry.com?subject=Plan Upgrade Request - Student Limit Reached&body=Hello,%0D%0A%0D%0AI have reached my student limit and would like to upgrade my plan.%0D%0A%0D%0ACurrent Students: {currentCount}%0D%0ACurrent Limit: {maxAllowed}%0D%0A%0D%0APlease help me upgrade.%0D%0A%0D%0AThank you."
            className="flex items-center space-x-3 p-4 bg-gray-50 dark:bg-gray-700/50 rounded-lg hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors border border-gray-200 dark:border-gray-600"
          >
            <Mail className="w-5 h-5 text-gray-600 dark:text-gray-400" />
            <div className="flex-1">
              <p className="text-sm font-medium text-gray-900 dark:text-white">Email Support</p>
              <p className="text-xs text-gray-500 dark:text-gray-400">support@mahstry.com</p>
            </div>
            <span className="text-gray-400">→</span>
          </a>
        </div>

        {/* Footer */}
        <div className="p-6 bg-gray-50 dark:bg-gray-700/50 rounded-b-lg">
          <p className="text-xs text-gray-600 dark:text-gray-400 text-center">
            Our team will help you upgrade to the right plan for your needs
          </p>
        </div>
      </div>
    </div>
  );
};

export default StudentLimitModal;
